import {
  Component,
  Input,
  HostBinding,
} from '@angular/core';
import * as _ from 'lodash';

import { BaseDropdownComponent } from '../_base-dropdown.component';
import { DropdownService } from '../dropdown.service';


@Component({
  moduleId: module.id,
  selector: 'dropdown-menu',
  templateUrl: 'dropdown-menu.component.html',
  styleUrls: ['dropdown-menu.component.scss'],
})
export class DropdownMenuComponent extends BaseDropdownComponent {

  /**
   * Dropdown menu alignment
   * https://v4-alpha.getbootstrap.com/components/dropdowns/#menu-alignment
  */
  @HostBinding('class.dropdown-menu') dropownMenu: boolean = true;

  @HostBinding('class.dropdown-menu-right')
  @Input() alignmentRight: boolean = false;

  @HostBinding('class.dropdown-menu-style-dark')
  @Input() darkStyle: boolean = false;

  @Input() optionGhostValue: string;

  @Input() declare selectedItem: any;

  constructor(
    private dropdownService: DropdownService
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get separatedItems() {
       // @ts-ignore
     return _.filter(this.items, {separated: true});
   }

   get notSeparatedItems() {
     return _.difference(this.items, this.separatedItems);
   }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public setActive(id: any, silent: boolean): void {
    const active = this.items.find((item: any) => item.id === id);
    this.selectedItem = active;
    if (silent) { return; }
    this.selectedChange.emit(this.selectedItem);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onDropdownItemClick(event: MouseEvent, item: any) {
    event.preventDefault();
    this.selectedItem = item;
    this.selectedChange.emit(item);
    this.dropdownService.close();
  }
}
